import { Controller } from "@hotwired/stimulus"

// Mobile sticky CTA: reveal once the hero is scrolled past. Ported from the LP's inline
// sticky IIFE. The bar itself is hidden on desktop via CSS. Classic JS only.
export default class extends Controller {
  static targets = ["bar"]

  connect() {
    this.hero = document.querySelector(".hero")
    if (!this.hasBarTarget || !this.hero) return
    this.lastVisible = false
    this.onScroll = () => this.check()
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.check()
  }

  disconnect() {
    if (this.onScroll) window.removeEventListener("scroll", this.onScroll)
  }

  check() {
    const shouldShow = this.hero.getBoundingClientRect().bottom < 0
    if (shouldShow !== this.lastVisible) {
      this.barTarget.classList.toggle("is-visible", shouldShow)
      this.lastVisible = shouldShow
    }
  }
}
